export default __webpack_public_path__ + "535cd02f963e1461091d87e0a6090935.svg";